import { useState } from 'react';

interface ContactModalProps {
  open: boolean;
  contactInfo: Api.Provider.ProviderContactResponse | null;
  onClose: () => void;
}

export default function ContactModal({ open, contactInfo, onClose }: ContactModalProps) {
  const [copiedField, setCopiedField] = useState<string | null>(null);

  if (!open || !contactInfo) return null;

  const handleCopyText = (text: string, field: string) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl relative animate-in fade-in zoom-in duration-200">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-foreground-400 hover:text-foreground-700 w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600">
            <i className="ri-contacts-line text-xl"></i>
          </div>
          <div>
            <h3 className="text-lg font-bold text-foreground-950">人才联系方式</h3>
            <p className="text-xs text-foreground-400">已通过企业认证获取授权</p>
          </div>
        </div>

        <div className="space-y-3.5 mb-6">
          {contactInfo.wechat_id && (
            <div className="flex items-center justify-between p-3.5 rounded-xl bg-gray-50 border border-gray-100">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-9 h-9 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] text-foreground-400">微信号</p>
                  <p className="text-sm font-semibold text-foreground-950 truncate">{contactInfo.wechat_id}</p>
                </div>
              </div>
              <button
                onClick={() => handleCopyText(contactInfo.wechat_id!, 'wechat')}
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white text-primary-600 border border-gray-200 hover:bg-primary-50 transition-colors cursor-pointer shrink-0 ml-2"
              >
                {copiedField === 'wechat' ? '已复制' : '复制'}
              </button>
            </div>
          )}

          {contactInfo.phone && (
            <div className="flex items-center justify-between p-3.5 rounded-xl bg-gray-50 border border-gray-100">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 flex-shrink-0">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] text-foreground-400">联系电话</p>
                  <p className="text-sm font-semibold text-foreground-950 truncate">{contactInfo.phone}</p>
                </div>
              </div>
              <button
                onClick={() => handleCopyText(contactInfo.phone!, 'phone')}
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white text-primary-600 border border-gray-200 hover:bg-primary-50 transition-colors cursor-pointer shrink-0 ml-2"
              >
                {copiedField === 'phone' ? '已复制' : '复制'}
              </button>
            </div>
          )}

          {contactInfo.email && (
            <div className="flex items-center justify-between p-3.5 rounded-xl bg-gray-50 border border-gray-100">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-9 h-9 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[11px] text-foreground-400">联系邮箱</p>
                  <p className="text-sm font-semibold text-foreground-950 truncate">{contactInfo.email}</p>
                </div>
              </div>
              <button
                onClick={() => handleCopyText(contactInfo.email!, 'email')}
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white text-primary-600 border border-gray-200 hover:bg-primary-50 transition-colors cursor-pointer shrink-0 ml-2"
              >
                {copiedField === 'email' ? '已复制' : '复制'}
              </button>
            </div>
          )}

          {!contactInfo.wechat_id && !contactInfo.phone && !contactInfo.email && (
            <div className="text-center py-6 text-foreground-400 text-sm">
              暂无更多联系方式
            </div>
          )}
        </div>

        <button
          onClick={onClose}
          className="w-full py-2.5 rounded-xl bg-gray-100 text-foreground-700 text-sm font-semibold hover:bg-gray-200 transition-colors cursor-pointer"
        >
          关闭
        </button>
      </div>
    </div>
  );
}
